let SwaggerBlendedHubApiExplorer = require('swagger');
//Overriding the base path
/*if ( document.location.href.indexOf('wp-admin') > -1 ) {
      const hostUrl = (window.location.href).split("wp-admin")[0]
      SwaggerBlendedHubApiExplorer.ApiClient.instance.basePath = hostUrl + "blended/v0" // For WP
} else {
      // SwaggerBlendedHubApiExplorer.ApiClient.instance.basePath = "http://10.72.15.111/sites/test2/blended/v0"
      SwaggerBlendedHubApiExplorer.ApiClient.instance.basePath = "http://52.20.249.96/hasan/blended/v0"
}*/



export class Network {
    constructor(session_key = null, hostUrl) {
      this.session_key =  this.getHubSessionKey ()
      this.sessionKey =  this.getSessionKey()
      SwaggerBlendedHubApiExplorer.ApiClient.instance.basePath = hostUrl
      SwaggerBlendedHubApiExplorer.ApiClient.instance.timeout  = 60000000000000000000000;
      this.SettingsApi = new SwaggerBlendedHubApiExplorer.SettingsApi()
      this.LibraryApi = new SwaggerBlendedHubApiExplorer.LibraryApi()
      this.AccountsApi =  new SwaggerBlendedHubApiExplorer.AccountsApi()
      this.PackagesApi = new SwaggerBlendedHubApiExplorer.PackagesApi()
      this.LocalApi = new SwaggerBlendedHubApiExplorer.LocalApi()

    }

    login (userName,  password , callback) {
      /* it will log in the with user name and password , currently the value are hard coded */
      const _this = this;
          this.SettingsApi.login({"user_name" : userName , "password" : password}, this.sessionKey,  (error, data,response) => {
                  if (error) {
                      return callback (error, response)
                  }
                  else if (data) {
                       if (data.session_key) {
                          _this.session_key =  data.session_key
                          localStorage.setItem ('session_key' , data.session_key)
                          localStorage.setItem ('sessionKey' , data.session_key)
                          localStorage.setItem ("userSlug" , data.slug);
                          _this.getCurrentAccount (data.slug,  function (userData) {

                          })
                       }
                       return callback (data, response)
                  }
                  else {
                    return callback ( new Error ("BlendedError"))
                  }
              })
    }

    userGet (callback) {
      this.AccountsApi.userGet ( this.sessionKey, ( error, data, response ) => {
        if(error){
          return callback( error, response )
        } else {
          return callback( data, response )
        }
      })
    }

    getSessionKey () {
      return localStorage.getItem ('sessionKey') || ''
    }

    getHubSessionKey () {
      return localStorage.getItem ('session_key')
    }

    logout (callback) {
      var _this = this;
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.SettingsApi.logout({"sessionkey" :  this.sessionKey}, this.sessionKey, (error, data, response)=>{
          if (error) {
             return callback(error, response)
           } else {
             localStorage.removeItem ('session_key')
             _this.session_key = null;
             return callback(data, response)
           }
        })
      }
    }

    createAccount  (body, callback) {
            var _this = this;
            this.AccountsApi.accountCreate(body,  this.sessionKey, (error, data, response)=>{
              if (error) {
                 return callback(error, response)
              } else {
                 //localStorage.removeItem ('session_key')
                return callback(data, response)
              }
            })
    }

    getAccountDetails (slug , callback) {
      const _this = this
      if (_this.session_key) {
        this.AccountsApi.accountDetails(slug, _this.sessionKey, (error, data, response)=> {
                if (error) {
                  return callback (error, response)
                } else {
                  return callback (data, response)
                }
              })
      }
      else {
        return callback ( new Error ("No session_key"))
      }
    }

    getAccountList (slug, callback) {
      const _this = this
      if (_this.session_key) {
           this.AccountsApi.accountMembershipList(slug, _this.sessionKey,  (error , data, response) =>{
             if (error) {
                return callback (error, response)
             } else {
                return callback (data, response)
             }
         })
      } else  {
         return callback ( new Error ("No session_key"))
      }
    }

    updateAccount (slug, body, callback) {
      const _this = this
            const opts = {
                            'sessionkey': _this.sessionKey // String | user session.
                          };
               this.AccountsApi.accountUpdate(slug, body, opts,  (error , data, response) =>{
                 if (error) {
                    return callback (error , response)
                 } else {
                    return callback (data, response)
                 }
             })
    }

    getCurrentAccount (slug, callback) {
      const _this = this
      if (_this.session_key) {
           this.AccountsApi.accountCurrentGet(slug, _this.sessionKey,  (error , data, response) =>{
             if (error) {
                return callback (error, response)
             } else {
               localStorage.setItem ('currentAccountSlug', JSON.parse(response.text))
                return callback (data, response)
             }
         })
      } else  {
         return callback ( new Error ("No session_key"))
      }
    }

    getUpdates(callback) {
       const _this = this
      if (_this.session_key) {
          this.SettingsApi.getUpdates(_this.sessionKey, (error, data, response)=> {
                  if (error) {
                    return callback(error, response)
                  } else {
                    return callback(data, response)
                  }
                })
        } else {
          return callback ( new Error ("No session_key"))
        }
    }

    setUpdates (body, callback) {
      const _this = this
      if (_this.session_key) {
          this.SettingsApi.setUpdates(body, _this.sessionKey, (error, data, response)=> {
                  if (error) {
                     return callback(error, response)
                  } else {
                    return callback(data, response)
                  }
                })
      } else {
          return callback ( new Error ("No session_key"))
        }
    }

    getPackages (opts, callback) {
      const _this = this
      if (!opts) {
        opts = {};
      }
          // if (_this.session_key) { // for offline
             this.LibraryApi.packageList (_this.sessionKey , opts,  (error, data, response) =>{
                 if (error) {
                    return callback (error, response)
                 } else {
                    return callback (data, response)
                 }
             })
          // } else  {
             // return callback ( new Error ("No session_key"))
          // }
    }

    getPackageDetails (accountSlug, slug ,callback) {
      const _this = this
      // if (_this.session_key) {  // for offline
         this.LibraryApi.draftDetails (accountSlug, slug, _this.sessionKey , (error, data, response) => {
             if (error) {
                return callback (error, response)
             } else {
                return callback (data, response)
             }
         })
       // } else {
        // return callback ( new Error ("No session_key"))
      // }
    }

    localDetails (accountSlug, slug ,callback) {
      const _this = this
      // if (_this.session_key) {  // for offline
         this.LocalApi.localDetails (accountSlug, slug, _this.sessionKey , (error, data, response) => {
             if (error) {
                return callback (error, response)
             } else {
                return callback (data, response)
             }
         })
       // } else {
        // return callback ( new Error ("No session_key"))
      // }
    }
    
    download (pk , callback) {
      const _this = this
          if (_this.session_key) {
             this.LibraryApi.download (pk, _this.sessionKey , (error, data, response) =>{
                 if (error) {
                    return callback (error, response)
                 } else {
                    return callback (data, response)
                 }
             })
          } else {
            return callback ( new Error ("No session_key"))
          }
    }

   // licence accusition ke saare


    save_hub (blended_project) {
           //Todo
    }

    validate_local (project_object) {
          //:Todo
    }

    validate_hub (project_object) {

    }

    save_js (name,content) {

    }

    save_css (name,content) {

    }

    get_image (image_url) {

    }

    load_image (image_url) {

    }

    save_image (image_name ,image_content) {

    }
    /* Rating */

    addRating (pk ,  callback) {
      if (this.session_key) {
        this.LibraryApi.ratingAdd(pk, this.sessionKey , (error, data, response) =>{
          return callback(data)
        });
      } else {
        if (error) {
           callback (error, response)
        } else {
           callback (data, response)
        }
      }
    }

    getRatings (pk , opts,  callback) {
      if (!opts) {
        opts = {'verbose': false}
      }
      if (!session_key) {
        return callback (new Error ("No session_key"))
      } else {
          this.LibraryApi.ratingsList(pk, this.sessionKey, opts, (error, data, response) => {
            if (error) {
               callback (error, response)
            } else {
               callback (data, response)
            }
          })
     }
    }

    getRatingDetails (pk, ratingPk, opts, callback) {
      if (!opts) {
        opts = {'verbose': false}
      }
      if (!this.session_key) {
          return callback (new Error ("No session_key"))
      } else {
          this.LibraryApi.ratingDetail(pk, ratingPk, this.sessionKey, opts, (error, data, response) => {
              if (error) {
                return (error, response)
              } else {
                return (data, response)
              }
           })
      }
    }

    updateRating (pk, ratingPk, body, callback) {
      if (this.session_key) {
        this.LibraryApi.ratingUpdate(this.session_key, pk, ratingPk, body, (error, data, response) => {
          return callback (data)
            if (error) {
              return (error, response)
            } else {
              return (data, response)            }
        })
      }
      else {
          return callback (new Error ("No session_key"))
      }
    }

    /* licence */
    getLicenses (pk, callback) {
      if (!this.session_key) {
          return callback (new Error ("No session_key"))
      } else {
        this.LibraryApi.getLicenses(pk, this.sessionKey, (error, data, response) => {
          if (error) {
             callback (error, response)
          } else {
             callback (data, response)
          }
        })
      }
    }

    removeLicense (pk, name, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LibraryApi.getLicenses(this.sessionKey, pk, name,  (error, data, response) => {
          if (error) {
             callback (error, response)
          } else {
             callback (data, response)
          }
        })
      }
    }

    updateLicense (name, pk, body, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LibraryApi.updateLicense(name, this.sessionKey, pk, body,  (error, data, response) => {
          if (error) {
             callback (error, response)
          } else {
             callback (data, response)
          }
        })
      }
    }

    /* accusition */

    packageShare (accountSlug, slug, body, callback) {
      //  var body = new SwaggerBlendedHubApiExplorer.Acquisition()
      //  console.log(body);
      // if (!this.session_key) {  // for offline
        // return callback (new Error ("No session_key"))
      // } else {
        this.LibraryApi.packageShare(accountSlug, slug, this.sessionKey, body,  (error, data, response) => {
          if (error) {
             callback (error, response)
          } else {
             callback (data, response)
          }
        })
      // }
    }

    pullPackage (accountSlug, slug, opts, callback) {
      if (!opts) {
              opts = {
                       'version': "version_example", // {String} version of package to be returned
                       'force': true // {String} boolean that forces a pulled package to overwrite the local package
                    };
      }
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
          this.LibraryApi.draftDownload (this.sessionKey, accountSlug, slug, opts, (error , data, response) => {
                if (data) {
                  return callback (data, response)
                } else {
                  return callback (error, response)
                }
          })
      }
    }

    pushPackage (accountSlug, slug, body, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
          this.LibraryApi.draftUpdate (this.sessionKey, accountSlug, slug, body, (error , data, response) => {
            if (data) {
              return callback (data, response)
            } else {
              return callback (error, response)
            }
          })
      }
    }

    versionCreateSnapshot (accountSlug, slug, body, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
          this.LibraryApi.versionCreateSnapshot (accountSlug, slug, this.sessionKey, body, (error , data, response) => {
            if (data) {
              return callback (data, response)
            } else {
              return callback (error, response)
            }
          })
      }
    }

    canonicalSet (accountSlug, slug, body, callback){
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
          this.PackagesApi.canonicalSet (accountSlug, slug, this.sessionKey, body, (error , data, response) => {
            if (data) {
              return callback (data, response)
            } else {
              return callback (error, response)
            }
          })
      }
    }

    canonicalDetails (accountSlug, slug, callback){
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
          this.LibraryApi.canonicalDetails (accountSlug, slug, this.sessionKey, (error , data, response) => {
            if (data) {
              return callback (data, response)
            } else {
              return callback (error, response)
            }
          })
      }
    }

    setCurrentAccount (slug, body, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.AccountsApi.accountCurrentSet(slug, this.sessionKey, body, (error, data, response)=>{
          if (error) {
            return callback(error, response);
           } else {
             return callback(data, response);
           }
        })
      }
    }


    resetPassword (body, callback) {
      // if (!this.sessionKey) {
      //   return callback (new Error ("No sessionKey"))
      // } else {
        this.SettingsApi.resetPassword(body, this.sessionKey, (error, data, response)=>{
          if (error) {
            return callback(error, response);
           } else {
             return callback(data, response);
           }
        });
      // }
    }

    getDependencies (slug, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LibraryApi.getDependencies(slug, this.sessionKey, (error, data, response)=> {
            if (error) {
              return callback(error,  response)
            } else {
              return callback(data,  response)
            }
       });
      }
    }

    preview (url, callback) {
      this.LibraryApi.preview (url , (error, data, response) =>{
        if (error) {
          return callback (error,  response);
        } else {
          return callback (data,  response);
        }
      });
    }

    draftCreate (accountSlug, slug, body, opts, callback) {
      if(!this.session_key){
        return callback (new Error ("No session_key"))
      } else {
        this.LibraryApi.draftCreate (this.sessionKey, accountSlug, slug, opts, (error, data, response) => {
          if (error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        })
      }
    }

    getFile (accountSlug, slug, fileName, callback) {
      if(!this.session_key){
        return callback (new Error ("No session_key"))
      } else {
        this.PackagesApi.draftDownloadFile(accountSlug, slug, fileName, this.sessionKey, (error, data, response) => {
          if (error){
            return callback(error, response)
          } else {
            return callback(data, response)
          }
        })
      }
    }

    versionList (accountSlug, slug, callback) {
      // if(!this.session_key){
      //   return callback (new Error ("No session_key"))
      // } else {
        this.LibraryApi.versionList(accountSlug, slug, this.sessionKey, (error, data, response) => {
          if (error){
            return callback(error, response)
          } else {
            return callback(data, response)
          }
        })
      // }
    }

    getActiveTheme (callback) {
      // if (!this.session_key) {  // for offline
          // return callback (new Error ("No session_key"))
        // } else {
        this.SettingsApi.activeTheme(this.sessionKey,  (error, data, response)=> {
          if (error) {
            return callback(error, response);
          } else {
            return callback(data, response);
          }
        })
      // }
    }

    makeActive(body, callback) {
    // if (!this.session_key) {  // for offline
        // return callback (new Error ("No session_key"))
      // } else {
        this.SettingsApi.activateTheme(body, this.sessionKey, (error, data, response)=> {
            if (error) {
              return callback(error, response);
            } else {
              return callback (data, response)
            }
        });
       // }
    }

    getThemeSettings (callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
          this.SettingsApi.getThemeSettings (this.sessionKey, (error, data, response)=>{
            if (error) {
                  return callback(error, response)
                } else {
                  return callback(data, response)
                }
          })
     }
    }

    setThemeSettings (opts, callback) {
      var opts = {
        'body': opts // {ThemeSettings} request data used to set theme settings.
      };
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
      this.SettingsApi.setThemeSettings (this.sessionKey, opts, (error, data, response) => {
        if (error) {
           return callback(error , response)
        } else {
           return  callback (data, response)
        }
      })
      }
    }

    getWordPressSettings (callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.SettingsApi.getWordPressSettings (this.sessionKey, (error, data, response)=>{
            if (error) {
              return callback(error, response)
            } else {
              return callback(data, response)
            }
        })
     }
    }

    setWordPressSettings (opts, callback) {
      var opts = {
        'body': opts // {ThemeSettings} request data used to set theme settings.
      };
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.SettingsApi.setWordPressSettings (this.sessionKey, opts, (error, data, response)=>{
            if (error) {
              return callback(error, response)
            } else {
              return callback(data, response)
            }
        })
      }
    }


    getNavigations (callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.SettingsApi.getNavigations (this.sessionKey, (error, data, response)=>{
          if (error) {
            return callback(error, response)
          } else {
            return callback(data, response)
          }
        })
      }
    }

    getNavigationsSetting (callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.SettingsApi.getNavigationsSetting (this.sessionKey, (error, data, response)=>{
          if (error) {
            return callback(error, response)
          } else {
            return callback(data, response)
          }
        })
      }
    }


    setNavigations (opts, callback) {
      var opts = {
        'body': opts // {ThemeSettings} request data used to set theme settings.
      };
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.SettingsApi.setNavigations (this.sessionKey, opts, (error, data, response)=>{
          if (error) {
            return callback(error, response)
          } else {
            return callback(data, response)
          }
        })
      }
    }


    localPackageGet (accountSlug, slug, callback) {
        this.LocalApi.localDetails (accountSlug, slug, this.sessionKey, (error, data, response)=>{
          if(error){
            return callback(error, response)
          } else {
            return callback(data, response)
          }
        })
    }

    localClone (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
      this.LocalApi.cloneFromLocal (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, body, opts, (error, data, response) => {
        if(error){
          return callback(error, response)
        } else {
          return callback(data, response)
        }
      })
    }

    canonicalClone (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.cloneFromCanonical (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, body, opts, (error, data, response) => {
          if (error){
            return callback(error, response)
          } else {
            return callback(data, response)
          }
        })
      }
    }

    localDelete (accountSlug, slug, body, callback) {
          this.LocalApi.localDelete (accountSlug, slug, this.sessionKey, body, (error, data, response) => {
            if (error){
              return callback(error, response)
            } else {
              return callback(data, response)
            }
          }) 
    }

    localDownload (accountSlug, slug, opts, callback){
        this.LocalApi.localDownload (accountSlug, slug, this.sessionKey, opts, (error, data, response) => {
          if (error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        })
      
    }

    localUpdate (accountSlug, slug, body, callback){
        this.LocalApi.localUpdate (this.sessionKey, accountSlug, slug, body, (error, data, response) => {
          if(error){
            return callback(error, response)
          } else {
            return callback (data, response)
          }
        })
    }

    localDownloadFile (accountSlug, slug, name, callback) {
        this.LocalApi.localDownloadFile (accountSlug, slug, name, this.sessionKey, (error, data, response) => {
          if(error){
            return callback(error, response)
          } else {
            return callback (data, response)
          }
        })
    }

    sharedPackageListGet (accountSlug, slug, opts, callback){
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LibraryApi.sharedPackageListGet (accountSlug, slug, this.sessionKey, opts, (error, data, response) => {
          if(error){
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        })
      }
       /*return callback({}, {"status": 200, "text": JSON.stringify(
          {
            "href":"http://127.0.0.1:8000/v0/packages/karan/a1/acquisitions/?share=1","items":[
              {"name":"karan/a1","shared_account":"legutierr","email":"roman@dbmonline.net","pending":false, "share_via_email": false},
              {"name":"karan/a1","shared_account":"adam","email":"adam@gmail.com","pending":false, "share_via_email": true},
              {"name":"karan/a1","shared_account":"legutierr","email":"roman@dbmonline.net","pending":true, "share_via_email": false},
              {"name":"karan/a1","shared_account":null,"email":"args2323@dbmonline.net","pending":true, "share_via_email": false},
              {"name":"karan/a1","shared_account":"abid","email":"abid@gmail.com","pending":true, "share_via_email": false},
              {"name":"karan/a1","shared_account":null,"email":"ashrivastava@gmail.com","pending":true, "share_via_email": true},
              {"name":"karan/a1","shared_account":"legutierr1","email":"legutierr1@gmail.com","pending":true, "share_via_email": true}
            ]
          }
       )});*/
    }


    revokeSharedPackage (accountSlug, slug, body, callback){
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.AccountsApi.revokeSharedPackage(accountSlug, slug, this.sessionKey, body, (error, data, response) => {
            if(error){
              return callback(error, response)
            } else {
              return callback(data, response)
            }
        })
      }
    }

    verifyEmail (accountSlug, slug, email, callback){
      var body = {"email": email};
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.AccountsApi.resendAccountVerificationEmail(this.sessionKey, body, (error, data, response) => {
            if(error){
              return callback(error, response)
            } else {
              return callback(data, response)
            }
        })
      }
    }

    rejectPackage (accountSlug, slug, body, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.PackagesApi.rejectAcquisitionInvite(accountSlug, slug, this.sessionKey, body, (error, data, response) => {
            if(error){
              return callback(error, response)
            } else {
              return callback(data, response)
            }
        })
      }
    }

    searchAccounts (value, callback) {
      // if (!this.session_key) {
      //   return callback (new Error ("No session_key"))
      // } else {
        this.AccountsApi.searchAccounts(this.sessionKey, value, (error, data, response) => {
            if(error){
              return callback(error, response)
            } else {
              return callback(data, response)
            }
        })
      // }
         /*return callback ({}, {"status": 200, "text": JSON.stringify({"list":
          [{"name": "legutierr", "email": "roman@dbmonline.net"},
          {"name": "args2323", "email": "args2323@dbmonline.net"},
          {"name": "eduardo@dbmonline.net", "email": "eduardo@dbmonline.net"},
          {"name": "abid@cognam.com", "email": "abid@dbmonline.net"},
          {"name": "ashrivastava@cognam.com", "email": "ashrivastava@dbmonline.net"},
          {"name": "srawat@cognam.com", "email": "srawat@dbmonline.net"},
          {"name": "legutierr1", "email": "legutierr1@dbmonline.net"},
          {"name": "legutierr2", "email": "legutierr2@dbmonline.net"}]
        })});*/
    }

    resendInvite (accountSlug, slug, body, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.PackagesApi.resendInvite (accountSlug, slug, this.sessionKey, body, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    compareWithCanonical (accountSlug1, slug1, accountSlug2, slug2, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.compareWithCanonical (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    compareWithDraft (accountSlug1, slug1, accountSlug2, slug2, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.compareWithDraft (this.sessionKey, accountSlug1, slug1, accountSlug2, slug2, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    compareWithLocal (accountSlug1, slug1, accountSlug2, slug2, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.compareWithLocal (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    compareWithVersion (accountSlug1, slug1, accountSlug2, slug2, label, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.compareWithVersion (accountSlug1, slug1, accountSlug2, slug2, label, this.sessionKey, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    updateFromCanonical (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.updateFromCanonical (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, body, opts, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    updateFromDraft (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.updateFromDraft (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, body, opts, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    updateFromLocal (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.updateFromLocal (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, body, opts, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    updateFromDraft (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.updateFromDraft (accountSlug1, slug1, accountSlug2, slug2, this.sessionKey, body, opts, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    updateFromVersion (accountSlug1, slug1, accountSlug2, slug2, label, body, opts, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LocalApi.updateFromVersion (accountSlug1, slug1, accountSlug2, slug2, label, this.sessionKey, body, opts, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }

    acceptAcquisition (accountSlug, slug, body, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.LibraryApi.acceptAcquisition (accountSlug, slug, this.sessionKey, body, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }


    getDependencies (accountSlug, slug, opts, callback) {
      if (!this.session_key) {
        return callback (new Error ("No session_key"))
      } else {
        this.PackagesApi.getDependencies (accountSlug, slug, this.sessionKey, opts, (error, data, response) => {
          if(error) {
            return callback (error, response)
          } else {
            return callback (data, response)
          }
        });
      }
    }
}


/** WEBPACK FOOTER **
 ** ./~/blended-hostlib-js/Controller/Network.js
 **/